import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=5efc6b29&scoped=true&lang=pug"
import script from "./Questionnaire.vue?vue&type=script&lang=ts"
export * from "./Questionnaire.vue?vue&type=script&lang=ts"
import style0 from "./Questionnaire.vue?vue&type=style&index=0&id=5efc6b29&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efc6b29",
  null
  
)

export default component.exports